module.exports = "/assets/2VBxIEvRwd.png";